import { useFormContext } from 'react-hook-form'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Label } from '@cocoonspace/ui/components/label'
import { Trans, useLingui } from '@lingui/react/macro'

import { EditBookingWindowDialog } from './edit-booking-window-dialog'
import { useGetFormattedDuration } from './use-get-formatted-duration'
import type { EditEventTypeFormData } from './../event-type-form'

const formatDuration = (duration: string) => {
	const dur = dateTimeUtils.duration(duration)
	const futureTime = dateTimeUtils().add(dur)
	return futureTime.format('dddd D MMMM [à] H[h]mm')
}

export const BookingWindowPreview = ({
	isOpen,
	setIsOpen,
}: {
	isOpen: boolean
	setIsOpen: (open: boolean) => void
}) => {
	const { t } = useLingui()
	const form = useFormContext<EditEventTypeFormData>()
	const bookingWindow = form.getValues('bookingWindow')
	const durations = useGetFormattedDuration()

	return (
		<div className='grid gap-y-2'>
			{bookingWindow && (
				<>
					<div className='grid grid-cols-2 gap-x-2'>
						<div className='grid'>
							<Label className='text-muted-foreground text-xs'>{t`Date de début`}</Label>

							<div className='text-sm'>
								{durations[bookingWindow.start as keyof typeof durations]}
							</div>
						</div>

						<div className='grid'>
							<Label className='text-muted-foreground text-xs'>{t`Date de fin`}</Label>

							<div className='text-sm'>
								{durations[bookingWindow.end as keyof typeof durations]}
							</div>
						</div>
					</div>

					<p className='bg-secondary rounded p-2 text-xs'>
						<Trans>
							Vous êtes disponible du{' '}
							<strong>{formatDuration(bookingWindow.start)}</strong> au{' '}
							<strong>{formatDuration(bookingWindow.end)}</strong>
						</Trans>
					</p>
				</>
			)}

			<EditBookingWindowDialog
				open={isOpen}
				onOpenChange={setIsOpen}
			/>
		</div>
	)
}
